export default __webpack_public_path__ + "assets/suriname-flag.png";